// ======================================================================
// FILE:
// src/modules/service_crm/satisfaction/components/SatisfactionFilterBar.js
//
// MODULE: Service CRM
// FEATURE: Satisfaction Filters
// ======================================================================

import React, {
  useState,
} from "react";

export default function SatisfactionFilterBar({

  filters = {},

  onApply,
}) {

  const [localFilters, setLocalFilters] =
    useState({

      q:
        filters.q || "",

      status:
        filters.status || "",

      engineer:
        filters.engineer || "",

      followup_executive:
        filters.followup_executive || "",

      date_from:
        filters.date_from || "",

      date_to:
        filters.date_to || "",
    });

  const updateField = (
    field,
    value
  ) => {

    setLocalFilters((prev) => ({

      ...prev,

      [field]: value,
    }));
  };

  const applyFilters = () => {

    const cleaned = {};

    Object.keys(
      localFilters
    ).forEach((key) => {

      const value =
        localFilters[key];

      if (
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {

        cleaned[key] = value;
      }
    });

    onApply(cleaned);
  };

  const clearFilters = () => {

    const reset = {

      q: "",

      status: "",

      engineer: "",

      followup_executive: "",

      date_from: "",

      date_to: "",
    };

    setLocalFilters(reset);

    onApply({});
  };

  return (

    <div

      style={{

        background: "#fff",

        borderRadius: 14,

        padding: 20,

        marginBottom: 20,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >

      {/* TITLE */}

      <div

        style={{

          fontSize: 16,

          fontWeight: 700,

          marginBottom: 18,
        }}
      >
        Search & Filters
      </div>

      {/* FILTER GRID */}

      <div

        style={{

          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit,minmax(250px,1fr))",

          gap: 14,
        }}
      >

        {/* SEARCH */}

        <div>

          <label>

            Search

          </label>

          <input

            type="text"

            value={
              localFilters.q
            }

            onChange={(e) =>
              updateField(
                "q",
                e.target.value
              )
            }

            placeholder="
Ticket / Customer / Contact"

            style={inputStyle}
          />

        </div>

        {/* STATUS */}

        <div>

          <label>

            Status

          </label>

          <select

            value={
              localFilters.status
            }

            onChange={(e) =>
              updateField(
                "status",
                e.target.value
              )
            }

            style={inputStyle}
          >

            <option value="">

              All

            </option>

            <option value="PENDING">

              Pending

            </option>

            <option value="COMPLETED">

              Completed

            </option>

          </select>

        </div>

        {/* ENGINEER */}

        <div>

          <label>

            Engineer

          </label>

          <input

            type="text"

            value={
              localFilters.engineer
            }

            onChange={(e) =>
              updateField(
                "engineer",
                e.target.value
              )
            }

            placeholder="
Engineer Name"

            style={inputStyle}
          />

        </div>

        {/* FOLLOWUP EXECUTIVE */}

        <div>

          <label>

            Follow-up Executive

          </label>

          <input

            type="text"

            value={
              localFilters
                .followup_executive
            }

            onChange={(e) =>
              updateField(
                "followup_executive",
                e.target.value
              )
            }

            placeholder="
Executive Name"

            style={inputStyle}
          />

        </div>

        {/* DATE FROM */}

        <div>

          <label>

            Date From

          </label>

          <input

            type="date"

            value={
              localFilters.date_from
            }

            onChange={(e) =>
              updateField(
                "date_from",
                e.target.value
              )
            }

            style={inputStyle}
          />

        </div>

        {/* DATE TO */}

        <div>

          <label>

            Date To

          </label>

          <input

            type="date"

            value={
              localFilters.date_to
            }

            onChange={(e) =>
              updateField(
                "date_to",
                e.target.value
              )
            }

            style={inputStyle}
          />

        </div>

      </div>

      {/* BUTTONS */}

      <div

        style={{

          display: "flex",

          justifyContent:
            "flex-end",

          gap: 10,

          marginTop: 18,
        }}
      >

        <button

          onClick={
            clearFilters
          }

          style={clearButtonStyle}
        >
          Clear
        </button>

        <button

          onClick={
            applyFilters
          }

          style={applyButtonStyle}
        >
          Apply Filters
        </button>

      </div>

    </div>
  );
}


// ======================================================================
// STYLES
// ======================================================================

const inputStyle = {

  width: "100%",

  padding: "10px 12px",

  border:
    "1px solid #ced4da",

  borderRadius: 8,

  marginTop: 6,
};

const clearButtonStyle = {

  background: "#fff",

  border:
    "1px solid #ced4da",

  padding:
    "8px 14px",

  borderRadius: 8,

  cursor: "pointer",
};

const applyButtonStyle = {

  background: "#0d6efd",

  color: "#fff",

  border: "none",

  padding:
    "8px 14px",

  borderRadius: 8,

  cursor: "pointer",
};